"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToMangopayAddress = transformToMangopayAddress;
const transformDomainCountryToMangopayCountry_1 = require("./transformDomainCountryToMangopayCountry");
function transformToMangopayAddress(address, country) {
    return {
        AddressLine1: address.addressLine1.trim(),
        AddressLine2: address.addressLine2?.trim() || undefined,
        City: address.city,
        Country: (0, transformDomainCountryToMangopayCountry_1.transformDomainCountryToMangopayCountry)(country.isoCode),
        Region: address.region || undefined,
        PostalCode: address.postalCode,
    };
}
//# sourceMappingURL=transformToMangopayAddress.js.map